import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import Swal from "sweetalert2";
import SettingModel from '../../models/SettingModel';
import  './css/switch.css';

import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import AppNotification from '../../helpers/AppNotification';
import { useDispatch } from 'react-redux';
import { setShowPreloader } from '../../redux/action';

// Validate của cấu hình hỗ trợ
const validationSchema_hotro = Yup.object().shape({
    nameTele_hotro: Yup.string().required('Vui lòng nhập tên Telegram'),
    hotline: Yup.string().required('Vui lòng nhập hotline'),
    pageName: Yup.string().required('Vui lòng nhập tên fanpage'),
    pagePath: Yup.string().required('Vui lòng nhập đường dẫn fanpage'),
    groupName: Yup.string().required('Vui lòng nhập tên group'),
    groupPath: Yup.string().required('Vui lòng nhập đường dẫn group'),
});

// Validate của cấu hình nạp tiền
const validationSchema_naptien = Yup.object().shape({
    // imageVIB: Yup.mixed().required('Vui lòng hình ảnh VIB'),
    // imageTCB: Yup.mixed().required('Vui lòng hình ảnh TCB'),
});

// Validate của cấu hình nạp tiền
const validationSchema_lienhe = Yup.object().shape({
    address: Yup.string().required('Vui lòng nhập địa chỉ'),
    phone: Yup.string().required('Vui lòng nhập số điện thoại'),
    email: Yup.string().required('Vui lòng nhập email'),
    nameTele_lienhe: Yup.string().required('Vui lòng nhập tên Telegram'),
    pathTele_lienhe: Yup.string().required('Vui lòng nhập đường dẫn Telegram'),
});

function SettingPage(props) {

    const dispatch = useDispatch();

    const [imageTCBpath, setImageTCBpath] = useState(null);
    const [imageVIBpath, setImageVIBpath] = useState(null);

    const [initialValues_hotro, setInitialValues_hotro] = useState({
        nameTele_hotro: '',
        hotline: '',
        pageName: '',
        pagePath: '',
        groupName: '',
        groupPath: '',
        type: 'hotro',
    });
    const [initialValues_naptien, setInitialValues_naptien] = useState({
        imageVIB: '',
        imageTCB: '',
        bankCodeTCB: '',
        bankNameVIB: '',
        bankNameTCB: '',
        bankCodeVIB: '',
        type: 'naptien',
        showBank1: true,
        showBank2: true,
    });
    const [initialValues_lienhe, setInitialValues_lienhe] = useState({
        address: '',
        phone: '',
        email: '',
        nameTele_lienhe: '',
        pathTele_lienhe: '',
        type: 'lienhe',
    });

    // State cho cổng TPBank Napas 247 Lookup
    const [tpbStatus, setTpbStatus] = useState({
        enabled: true,
        fallback_banklookup: true,
        username: '096*****121',
        debtor_account_number: '234*****333',
        account_owner_name: 'NG***** TUNG',
        status: 'OFFLINE',
        waiting_seconds_left: 0,
        last_keepalive_at: null,
        last_error: '',
        total_lookups: 0,
        cached_accounts_count: 0,
    });
    const [tpbForm, setTpbForm] = useState({
        username: '096*****121',
        password: '',
        debtor_account_number: '234*****333',
        enabled: true,
        fallback_banklookup: true,
    });
    const [testLookupForm, setTestLookupForm] = useState({
        bin: '970436',
        bank_code: 'VCB',
        account_number: '',
        bypass_cache: true,
    });
    const [testLookupResult, setTestLookupResult] = useState(null);
    const [isTestingLookup, setIsTestingLookup] = useState(false);
    const [isTriggeringLogin, setIsTriggeringLogin] = useState(false);

    const loadTpbankStatus = (updateForm = false) => {
        SettingModel.getTpbankStatus()
            .then(res => {
                if (res && res.data) {
                    setTpbStatus(res.data);
                    if (updateForm) {
                        setTpbForm({
                            username: res.data.username || '096*****121',
                            password: '',
                            debtor_account_number: res.data.debtor_account_number || '234*****333',
                            enabled: res.data.enabled !== false,
                            fallback_banklookup: res.data.fallback_banklookup !== false,
                        });
                    }
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        loadTpbankStatus(true);
        const timer = setInterval(() => {
            loadTpbankStatus(false);
        }, 3000);
        return () => clearInterval(timer);
    }, []);

    const handleSaveTpbConfig = () => {
        SettingModel.updateTpbankConfig(tpbForm)
            .then(res => {
                Swal.fire({
                    icon: 'success',
                    title: res.message || 'Đã lưu cấu hình TPBank!',
                    timer: 1800,
                    showConfirmButton: false,
                });
                loadTpbankStatus(false);
            })
            .catch(() => {
                Swal.fire({ icon: 'error', title: 'Lưu cấu hình thất bại!' });
            });
    };

    const handleStartTpbLogin = () => {
        setIsTriggeringLogin(true);
        SettingModel.startTpbankLogin()
            .then(res => {
                setIsTriggeringLogin(false);
                loadTpbankStatus(false);
                if (res.status === 'ONLINE') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Kết nối TPBank thành công!',
                        text: res.message,
                    });
                } else if (res.status === 'WAITING_CONFIRM') {
                    Swal.fire({
                        icon: 'info',
                        title: '📲 Hãy mở App TPBank trên điện thoại!',
                        html: `<div style="line-height:1.6;text-align:left;">
                            <p>Hệ thống vừa gửi thông báo xác nhận đăng nhập về <b>App TPBank trên điện thoại</b> của bạn.</p>
                            <p>1. Bấm vào thông báo và <b>Xác nhận đăng nhập</b> trong vòng 60 giây.</p>
                            <p>2. <b style="color:#ef4444;">Lưu ý quan trọng:</b> Sau khi bấm Xác nhận xong, hãy thoát App TPBank ngay (không đăng nhập tiếp vào bên trong App điện thoại) để Server giữ phiên 24/7.</p>
                        </div>`,
                        confirmButtonText: 'Đã hiểu (Đang tự động chờ xác nhận...)',
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Không thể khởi tạo đăng nhập',
                        text: res.message || 'Vui lòng thử lại sau vài giây.',
                    });
                }
            })
            .catch(err => {
                setIsTriggeringLogin(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Lỗi kết nối',
                    text: err?.message || 'Không thể gọi API đăng nhập TPBank',
                });
            });
    };

    const handleKeepAliveTpb = () => {
        SettingModel.keepAliveTpbank().then(res => {
            loadTpbankStatus(false);
            if (res.status === 'ONLINE') {
                AppNotification.showSuccess('Phiên TPBank đang hoạt động tốt (ONLINE)!');
            } else {
                AppNotification.showError(res.message || 'Phiên TPBank đã ngắt, vui lòng bấm Kết nối lại!');
            }
        });
    };

    const handleTestLookup = (e) => {
        e.preventDefault();
        if (!testLookupForm.account_number.trim()) {
            AppNotification.showError('Vui lòng nhập số tài khoản cần tra cứu!');
            return;
        }
        setIsTestingLookup(true);
        setTestLookupResult(null);
        SettingModel.testTpbankLookup(testLookupForm)
            .then(res => {
                setIsTestingLookup(false);
                setTestLookupResult(res);
            })
            .catch(err => {
                setIsTestingLookup(false);
                setTestLookupResult({
                    success: false,
                    message: err?.response?.data?.message || err?.message || 'Không tìm thấy số tài khoản hoặc phiên TPBank chưa kết nối',
                });
            });
    };


    useEffect(() => {
        dispatch(setShowPreloader(true));
        SettingModel.getAll({})
            .then(res => {
                let hotroPrev = {
                    nameTele_hotro: res.data.find(item => item.key === 'nameTele_hotro')?.value,
                    hotline: res.data.find(item => item.key === 'hotline')?.value,
                    pageName: res.data.find(item => item.key === 'pageName')?.value,
                    pagePath: res.data.find(item => item.key === 'pagePath')?.value,
                    groupName: res.data.find(item => item.key === 'groupName')?.value,
                    groupPath: res.data.find(item => item.key === 'groupPath')?.value,
                };

                let lienhePrev = {
                    address: res.data.find(item => item.key === 'address')?.value,
                    phone: res.data.find(item => item.key === 'phone')?.value,
                    email: res.data.find(item => item.key === 'email')?.value,
                    nameTele_lienhe: res.data.find(item => item.key === 'nameTele_lienhe')?.value,
                    pathTele_lienhe: res.data.find(item => item.key === 'pathTele_lienhe')?.value,
                };

                let vibPath = res.data.find(item => item.key === 'imageVIB')?.value;
                let tcbPath = res.data.find(item => item.key === 'imageTCB')?.value;

                let naptienPrev = {
                    imageVIB: '',
                    imageTCB: '',
                    bankCodeTCB: res.data.find(item => item.key === 'bankCodeTCB')?.value,
                    bankCodeVIB: res.data.find(item => item.key === 'bankCodeVIB')?.value,
                    bankNameVIB: res.data.find(item => item.key === 'bankNameVIB')?.value,
                    bankNameTCB: res.data.find(item => item.key === 'bankNameTCB')?.value,
                    showBank1: res.data.find(item => item.key === 'showBank1')?.value === 'true',
                    showBank2: res.data.find(item => item.key === 'showBank2')?.value === 'true',
                };

                setInitialValues_hotro(hotroPrev);
                setInitialValues_lienhe(lienhePrev);
                setInitialValues_naptien(naptienPrev);

                setImageTCBpath(vibPath);
                setImageVIBpath(tcbPath);

                dispatch(setShowPreloader(false));
            }).catch(err => {
                console.log(err);
                AppNotification.showError('Lấy dữ liệu thất bại!');
            })
    }, []);
    const onSubmit = (values) => {
        dispatch(setShowPreloader(true));
        SettingModel.create(values).then((res) => {
            if (res.success) {
                console.log(res);
                dispatch(setShowPreloader(false));
                Swal.fire({
                    icon: "success",
                    title: "Lưu thành công!",
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        }).catch((err) => {
            dispatch(setShowPreloader(false));
            Swal.fire({
                icon: "error",
                title: "Lưu thất bại!",
                showConfirmButton: false,
                timer: 2000,
            });
        })
    };

    const onSubmitImage = (values) => {

        dispatch(setShowPreloader(true));

        const formData = new FormData();
        if (values.imageTCB) {
            formData.append('imageTCB', values.imageTCB);
        }
        if (values.imageVIB) {
            formData.append('imageVIB', values.imageVIB);
        }

        formData.append('bankCodeVIB', values.bankCodeVIB);
        formData.append('bankNameVIB', values.bankNameVIB);
        formData.append('bankCodeTCB', values.bankCodeTCB);
        formData.append('bankNameTCB', values.bankNameTCB);
        formData.append('showBank1', values.showBank1);
        formData.append('showBank2', values.showBank2);

        SettingModel.createImage(formData).then((res) => {
            if (res.success) {
                dispatch(setShowPreloader(false));

                let vibPath = res.data.imageVIB;
                let tcbPath = res.data.imageTCB;

                if(vibPath){
                    setImageTCBpath(vibPath);
                }
                if(tcbPath){
                    setImageVIBpath(tcbPath);
                }

                Swal.fire({
                    icon: "success",
                    title: "Lưu thành công!",
                    showConfirmButton: false,
                    timer: 2000,
                });
            }
        }).catch((err) => {
            dispatch(setShowPreloader(false));
            Swal.fire({
                icon: "error",
                title: "Lưu thất bại!",
                showConfirmButton: false,
                timer: 2000,
            });
        })
    };

    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Quản lí cấu hình" />

            {/* Cổng Tra Cứu STK TPBank Napas 247 */}
            <div className="row mb-4">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <div>
                                <h4 className="card-title mb-1">🏦 Cổng Tự Động Check STK Liên Ngân Hàng (TPBank Napas 247)</h4>
                                <small className="text-muted">
                                    Tra cứu tên chủ tài khoản 60+ ngân hàng hoàn toàn miễn phí qua phiên TPBank nội bộ + Kho Cache vĩnh viễn
                                </small>
                            </div>
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                {tpbStatus.status === 'ONLINE' && (
                                    <span className="badge badge-success px-3 py-2" style={{ fontSize: '13px' }}>
                                        🟢 ĐANG KẾT NỐI (ONLINE - Tự động giữ phiên 24/7)
                                    </span>
                                )}
                                {tpbStatus.status === 'WAITING_CONFIRM' && (
                                    <span className="badge badge-warning px-3 py-2" style={{ fontSize: '13px' }}>
                                        🟡 ĐANG CHỜ XÁC NHẬN APP TPBANK ({tpbStatus.waiting_seconds_left || 0}s)
                                    </span>
                                )}
                                {tpbStatus.status === 'OFFLINE' && (
                                    <span className="badge badge-danger px-3 py-2" style={{ fontSize: '13px' }}>
                                        🔴 CHƯA KẾT NỐI (OFFLINE)
                                    </span>
                                )}
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    disabled={isTriggeringLogin || tpbStatus.status === 'WAITING_CONFIRM'}
                                    onClick={handleStartTpbLogin}
                                >
                                    {tpbStatus.status === 'WAITING_CONFIRM'
                                        ? `📲 Đang chờ xác nhận trên điện thoại (${tpbStatus.waiting_seconds_left || 0}s)...`
                                        : '📲 Kết nối / Xác nhận App TPBank'}
                                </button>
                                {tpbStatus.status === 'ONLINE' && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        onClick={handleKeepAliveTpb}
                                    >
                                        🔄 Kiểm tra phiên
                                    </button>
                                )}
                            </div>
                        </div>
                        <div className="card-body">
                            {tpbStatus.last_error && tpbStatus.status !== 'ONLINE' && (
                                <div className="alert alert-danger py-2 mb-3" style={{ fontSize: '13px' }}>
                                    <strong>Thông báo phiên:</strong> {tpbStatus.last_error}
                                </div>
                            )}
                            {tpbStatus.status === 'WAITING_CONFIRM' && (
                                <div className="alert alert-warning py-2 mb-3" style={{ fontSize: '13.5px' }}>
                                    <strong>📲 Đang chờ bạn bấm Xác nhận trên App TPBank điện thoại!</strong> Sau khi bấm Xác nhận trên điện thoại xong, vui lòng <b>thoát App TPBank ra ngoài</b> (không đăng nhập tiếp vào màn hình chính của App điện thoại) để Server giữ phiên liên tục.
                                </div>
                            )}

                            <div className="row">
                                {/* Cột 1: Cấu hình Tài khoản TPBank */}
                                <div className="col-lg-6 mb-3">
                                    <div className="p-3 rounded" style={{ border: '1px solid var(--border-subtle, rgba(148,163,184,0.2))' }}>
                                        <h6 className="mb-3" style={{ fontWeight: 700 }}>1. Cấu hình Tài khoản TPBank & Cơ chế</h6>
                                        <div className="row g-2">
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label small mb-1">Tài khoản TPBank</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{ filter: 'blur(4px)', transition: 'filter 0.2s' }}
                                                    onFocus={e => (e.target.style.filter = 'none')}
                                                    onBlur={e => (e.target.style.filter = 'blur(4px)')}
                                                    value={tpbForm.username}
                                                    onChange={e => setTpbForm({ ...tpbForm, username: e.target.value })}
                                                    placeholder="096*****121"
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label small mb-1">Mật khẩu TPBank</label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    value={tpbForm.password}
                                                    onChange={e => setTpbForm({ ...tpbForm, password: e.target.value })}
                                                    placeholder="••••••••••••"
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label small mb-1">STK Nguồn TPBank</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    style={{ filter: 'blur(4px)', transition: 'filter 0.2s' }}
                                                    onFocus={e => (e.target.style.filter = 'none')}
                                                    onBlur={e => (e.target.style.filter = 'blur(4px)')}
                                                    value={tpbForm.debtor_account_number}
                                                    onChange={e => setTpbForm({ ...tpbForm, debtor_account_number: e.target.value })}
                                                    placeholder="234*****333"
                                                />
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <label className="form-label small mb-1">Chủ Tài khoản & Thống kê</label>
                                                <div className="form-control d-flex align-items-center justify-content-between" style={{ fontSize: '12.5px' }}>
                                                    <span
                                                        style={{ filter: 'blur(4px)', transition: 'filter 0.2s', cursor: 'pointer' }}
                                                        onMouseEnter={e => (e.currentTarget.style.filter = 'none')}
                                                        onMouseLeave={e => (e.currentTarget.style.filter = 'blur(4px)')}
                                                        title="Di chuột vào để xem"
                                                    >
                                                        <strong>{tpbStatus.account_owner_name || '---'}</strong>
                                                    </span>
                                                    <span className="text-muted">Đã tra: <b>{tpbStatus.total_lookups || 0}</b> | Kho Cache: <b>{tpbStatus.cached_accounts_count || 0}</b></span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-2 pt-2" style={{ borderTop: '1px solid var(--border-subtle, rgba(148,163,184,0.15))' }}>
                                            <div className="d-flex gap-3 flex-wrap">
                                                <label className="d-flex align-items-center gap-1 mb-0" style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={tpbForm.enabled}
                                                        onChange={e => setTpbForm({ ...tpbForm, enabled: e.target.checked })}
                                                    />
                                                    <span>Bật Cổng TPBank Napas 247</span>
                                                </label>
                                                <label className="d-flex align-items-center gap-1 mb-0" style={{ cursor: 'pointer', fontSize: '13px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={tpbForm.fallback_banklookup}
                                                        onChange={e => setTpbForm({ ...tpbForm, fallback_banklookup: e.target.checked })}
                                                    />
                                                    <span>Tự động dự phòng banklookup.net nếu mất phiên</span>
                                                </label>
                                            </div>
                                            <button type="button" className="btn btn-success btn-sm" onClick={handleSaveTpbConfig}>
                                                💾 Lưu cấu hình
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Cột 2: Khung Test Tra Cứu STK Trực Tiếp */}
                                <div className="col-lg-6 mb-3">
                                    <div className="p-3 rounded h-100" style={{ border: '1px solid var(--border-subtle, rgba(148,163,184,0.2))' }}>
                                        <h6 className="mb-3" style={{ fontWeight: 700 }}>2. Tra Cứu Thử STK Liên Ngân Hàng</h6>
                                        <form onSubmit={handleTestLookup}>
                                            <div className="row g-2">
                                                <div className="col-md-5 mb-2">
                                                    <label className="form-label small mb-1">Chọn Ngân hàng</label>
                                                    <select
                                                        className="form-control"
                                                        value={`${testLookupForm.bin}|${testLookupForm.bank_code}`}
                                                        onChange={e => {
                                                            const [b, c] = e.target.value.split('|');
                                                            setTestLookupForm({ ...testLookupForm, bin: b, bank_code: c });
                                                        }}
                                                    >
                                                        <option value="970436|VCB">Vietcombank (VCB)</option>
                                                        <option value="970422|MB">MB Bank (MB)</option>
                                                        <option value="970407|TCB">Techcombank (TCB)</option>
                                                        <option value="970418|BIDV">BIDV</option>
                                                        <option value="970415|ICB">VietinBank (ICB)</option>
                                                        <option value="970416|ACB">ACB</option>
                                                        <option value="970423|TPB">TPBank (TPB)</option>
                                                        <option value="970405|VBA">Agribank (VBA)</option>
                                                        <option value="970432|VPB">VPBank (VPB)</option>
                                                        <option value="970403|STB">Sacombank (STB)</option>
                                                        <option value="970441|VIB">VIB</option>
                                                        <option value="970443|SHB">SHB</option>
                                                        <option value="970437|HDB">HDBank (HDB)</option>
                                                        <option value="970426|MSB">MSB</option>
                                                        <option value="970448|OCB">OCB</option>
                                                        <option value="970449|LPB">LPBank (LPB)</option>
                                                        <option value="970431|EIB">Eximbank (EIB)</option>
                                                        <option value="970440|SEAB">SeABank</option>
                                                        <option value="970425|ABB">ABBank</option>
                                                        <option value="970409|BAB">Bac A Bank</option>
                                                        <option value="970438|BVBANK">BaoViet Bank</option>
                                                        <option value="970454|VCCB">BVBank (Bản Việt)</option>
                                                        <option value="970412|PVCB">PVcomBank</option>
                                                        <option value="970428|NAB">Nam A Bank</option>
                                                        <option value="970419|NCB">NCB</option>
                                                        <option value="970433|VIETBANK">VietBank</option>
                                                        <option value="963388|TIMO">Timo</option>
                                                        <option value="546034|CAKE">CAKE by VPBank</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-7 mb-2">
                                                    <label className="form-label small mb-1">Số tài khoản cần kiểm tra</label>
                                                    <div className="d-flex gap-2">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={testLookupForm.account_number}
                                                            onChange={e => setTestLookupForm({ ...testLookupForm, account_number: e.target.value })}
                                                            placeholder="Nhập số tài khoản..."
                                                        />
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary"
                                                            disabled={isTestingLookup}
                                                            style={{ whiteSpace: 'nowrap' }}
                                                        >
                                                            {isTestingLookup ? 'Đang tra...' : '🔍 Check STK'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between mt-1">
                                                <label className="d-flex align-items-center gap-1 mb-0" style={{ cursor: 'pointer', fontSize: '12.5px' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={testLookupForm.bypass_cache}
                                                        onChange={e => setTestLookupForm({ ...testLookupForm, bypass_cache: e.target.checked })}
                                                    />
                                                    <span>Gọi thẳng TPBank Napas 247</span>
                                                </label>
                                                {tpbStatus.last_keepalive_at && (
                                                    <span className="text-muted" style={{ fontSize: '11.5px' }}>
                                                        Keep-alive gần nhất: {new Date(tpbStatus.last_keepalive_at).toLocaleTimeString('vi-VN')}
                                                    </span>
                                                )}
                                            </div>
                                        </form>

                                        {testLookupResult && (
                                            <div
                                                className={`mt-3 p-2.5 rounded ${testLookupResult.success ? 'alert alert-success' : 'alert alert-danger'} mb-0`}
                                                style={{ fontSize: '13.5px', padding: '10px 14px' }}
                                            >
                                                {testLookupResult.success ? (
                                                    <div>
                                                        <div>
                                                            Chủ tài khoản: <strong style={{ fontSize: '15px' }}>{testLookupResult.account_name}</strong>
                                                        </div>
                                                        <div className="small mt-1">
                                                            Nguồn: <b>{testLookupResult.source === 'tpbank' ? '🏦 Trực tiếp TPBank Napas 247' : '⚡ Kho Cache DB nội bộ'}</b> — Thời gian: <b>{testLookupResult.ms}ms</b>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <strong>Kết quả:</strong> {testLookupResult.message}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {false && (
                <>
            {/* Cấu hình hỗ trợ */}
            <div className='row'>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <div className='row'>
                                <h4 className="card-title">Cấu hình hỗ trợ</h4>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className='table-responsive'>
                                <Formik
                                    initialValues={initialValues_hotro}
                                    validationSchema={validationSchema_hotro}
                                    enableReinitialize={true}
                                    onSubmit={(values) => onSubmit(values)}
                                >
                                    {({ errors, touched, setFieldValue }) => (
                                        <Form>
                                            <table className="table header-border table-responsive-sm">
                                                <thead>
                                                    <tr>
                                                        <th className="align-top">Telegram</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập đường dẫn telegram...'
                                                                id="nameTele_hotro"
                                                                name="nameTele_hotro"
                                                            />
                                                            <ErrorMessage name="nameTele_hotro" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="align-top">Hotline</th>
                                                        <td>
                                                            <Field
                                                                type='number'
                                                                className='form-control'
                                                                placeholder='Nhập số hotline...'
                                                                id="hotline"
                                                                name="hotline"
                                                            />
                                                            <ErrorMessage name="hotline" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="align-top">Fanpage</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập tên hiển thị fanpage...'
                                                                id="pageName"
                                                                name="pageName"
                                                            />
                                                            <ErrorMessage name="pageName" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                            <Field
                                                                type='text'
                                                                className='form-control mt-3'
                                                                placeholder='Nhập đường dẫn liên kết fanpage...'
                                                                id="pagePath"
                                                                name="pagePath"
                                                            />
                                                            <ErrorMessage name="pagePath" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="align-top">Group</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập tên hiển thị group...'
                                                                id="groupName"
                                                                name="groupName"
                                                            />
                                                            <ErrorMessage name="groupName" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                            <Field
                                                                type='text'
                                                                className='form-control mt-3'
                                                                placeholder='Nhập đường dẫn liên kết group...'
                                                                id="groupPath"
                                                                name="groupPath"
                                                            />
                                                            <ErrorMessage name="groupPath" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>
                                            <button type="submit" className="btn btn-success" style={{ float: 'right' }}>
                                                Xác nhận
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Nạp tiền tự động */}
            <div className='row'>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <div className='row'>
                                <h4 className="card-title">Nạp tiền tự động</h4>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className='table-responsive'>
                                <Formik
                                    initialValues={initialValues_naptien}
                                    validationSchema={validationSchema_naptien}
                                    enableReinitialize={true}
                                    onSubmit={(values) => onSubmitImage(values)}
                                >
                                    {({ errors, touched, setFieldValue, values }) => (
                                        <Form>
                                            <table className="table header-border table-responsive-sm">
                                                <thead>
                                                <tr>
                                                    <td style={{borderBottom: "none"}} className="align-middle">Hiển thị
                                                        bank
                                                    </td>
                                                    <td style={{borderBottom: "none"}} className="col-lg-4">
                                                        <label className="text-label form-label">
                                                            <div className="switcher animate mt-2">
                                                                <input
                                                                    type="checkbox"
                                                                    name="showBank1"
                                                                    checked={initialValues_naptien.showBank1}
                                                                    onChange={() => {
                                                                        setInitialValues_naptien(prevState => ({
                                                                            ...prevState,
                                                                            showBank1: !prevState.showBank1
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{borderBottom: "none"}} className="align-middle">Ảnh
                                                        QR 1
                                                    </td>
                                                    <td style={{borderBottom: "none"}} className="col-lg-4">
                                                        <Field name="imageTCB">
                                                            {({field}) => (
                                                                <>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        id="imageTCB"
                                                                        name="imageTCB"
                                                                        onChange={(event) => {
                                                                            setFieldValue("imageTCB", event.currentTarget.files[0]);
                                                                        }}
                                                                    />
                                                                </>
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="imageVIB" component="div"
                                                                      className="ml-2 mt-2 error-message text-danger"/>
                                                    </td>
                                                    <td rowSpan="3">
                                                        {imageVIBpath && (
                                                            <td className="col-lg-12">
                                                                <img className="img-fluid" height={250} width={250}
                                                                     src={imageVIBpath} alt="QR VIB"/>
                                                            </td>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{borderBottom: "none"}} className="align-middle">Số tài
                                                        khoản 1
                                                    </td>
                                                    <td style={{borderBottom: "none"}}>
                                                        <Field
                                                            type='text'
                                                            className='form-control'
                                                            placeholder='Số tài khoản VIB'
                                                            id="bankCodeVIB"
                                                            name="bankCodeVIB"
                                                        />
                                                        <ErrorMessage name="bankCodeVIB" component="div"
                                                                      className="ml-2 mt-2 error-message text-danger"/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="align-middle">Tên tài khoản 1</td>
                                                    <td>
                                                        <Field
                                                            type='text'
                                                            className='form-control'
                                                            placeholder='Tên tài khoản VIB'
                                                            id="bankNameVIB"
                                                            name="bankNameVIB"
                                                        />
                                                        <ErrorMessage name="bankNameVIB" component="div"
                                                                      className="ml-2 mt-2 error-message text-danger"/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{borderBottom: "none"}} className="align-middle">Hiển thị
                                                        bank
                                                    </td>
                                                    <td style={{borderBottom: "none"}} className="col-lg-4">
                                                        <label className="text-label form-label">
                                                            <div className="switcher animate mt-2">
                                                                <input
                                                                    type="checkbox"
                                                                    name="showBank1"
                                                                    checked={initialValues_naptien.showBank2}
                                                                    onChange={() => {
                                                                        setInitialValues_naptien(prevState => ({
                                                                            ...prevState,
                                                                            showBank2: !prevState.showBank2
                                                                        }));
                                                                    }}
                                                                />
                                                            </div>
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{borderBottom: "none"}} className="align-middle">Ảnh QR
                                                        2
                                                    </td>
                                                    <td style={{borderBottom: "none"}}>
                                                        <Field name="imageVIB">
                                                            {({field}) => (
                                                                <>
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        id="imageVIB"
                                                                        name="imageVIB"
                                                                        onChange={(event) => {
                                                                            setFieldValue("imageVIB", event.currentTarget.files[0]);
                                                                        }}
                                                                    />
                                                                </>
                                                            )}
                                                        </Field>
                                                        <ErrorMessage name="imageTCB" component="div"
                                                                      className="ml-2 mt-2 error-message text-danger"/>
                                                    </td>
                                                    <td rowSpan="3">
                                                        {imageTCBpath && (
                                                            <td>
                                                                <img className="img-fluid" height={250} width={250}
                                                                     src={imageTCBpath} alt="QR VIB"/>
                                                            </td>
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style={{borderBottom: "none"}} className="align-middle">Số tài
                                                        khoản 2
                                                    </td>
                                                    <td style={{borderBottom: "none"}}>
                                                        <Field
                                                            type='text'
                                                            className='form-control'
                                                            placeholder='Số tài khoản TCB'
                                                            id="bankCodeTCB"
                                                            name="bankCodeTCB"
                                                        />
                                                        <ErrorMessage name="bankCodeTCB" component="div"
                                                                      className="ml-2 mt-2 error-message text-danger"/>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="align-middle">Tên tài khoản 2</td>
                                                    <td>
                                                        <Field
                                                            type='text'
                                                            className='form-control'
                                                            placeholder='Tên tài khoản TCB'
                                                            id="bankNameTCB"
                                                            name="bankNameTCB"
                                                        />
                                                        <ErrorMessage name="bankNameTCB" component="div"
                                                                      className="ml-2 mt-2 error-message text-danger"/>
                                                    </td>
                                                </tr>
                                                </thead>
                                            </table>
                                            <button type="submit" className="btn btn-success" style={{float: 'right'}}>
                                                Xác nhận
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Cấu hình liên hệ */}
            <div className='row'>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <div className='row'>
                                <h4 className="card-title">Cấu hình liên hệ</h4>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className='table-responsive'>
                                <Formik
                                    initialValues={initialValues_lienhe}
                                    validationSchema={validationSchema_lienhe}
                                    enableReinitialize={true}
                                    onSubmit={(values) => onSubmit(values)}
                                >
                                    {({ errors, touched, setFieldValue }) => (
                                        <Form>
                                            <table className="table header-border table-responsive-sm">
                                                <thead>
                                                    <tr>
                                                        <th className="align-top">Địa chỉ</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập địa chỉ...'
                                                                id="address"
                                                                name="address"
                                                            />
                                                            <ErrorMessage name="address" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="align-top">Số điện thoại</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập số số điện thoại...'
                                                                id="phone"
                                                                name="phone"
                                                            />
                                                            <ErrorMessage name="phone" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="align-top">Email</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập email...'
                                                                id="email"
                                                                name="email"
                                                            />
                                                            <ErrorMessage name="email" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <th className="align-top">Telegram</th>
                                                        <td>
                                                            <Field
                                                                type='text'
                                                                className='form-control'
                                                                placeholder='Nhập tên hiển thị telegram...'
                                                                id="nameTele_lienhe"
                                                                name="nameTele_lienhe"
                                                            />
                                                            <ErrorMessage name="nameTele_lienhe" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                            <Field
                                                                type='text'
                                                                className='form-control mt-3'
                                                                placeholder='Nhập đường dẫn liên kết telegram...'
                                                                id="pathTele_lienhe"
                                                                name="pathTele_lienhe"
                                                            />
                                                            <ErrorMessage name="pathTele_lienhe" component="div" className="ml-2 mt-2 error-message text-danger" />
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </table>
                                            <button type="submit" className="btn btn-success" style={{ float: 'right' }}>
                                                Xác nhận
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                </>
            )}
        </MasterLayout>
    );
}

export default SettingPage;
